// extracted by mini-css-extract-plugin
export default {"appContainer":"Home_appContainer__7OFdl","homePageContainer":"Home_homePageContainer__DTcfy","title":"Home_title__9cK06","tm":"Home_tm__oAatI"};